import React from 'react';
import classNames from 'classnames';
import { getStyles as getActionButtonStyles } from './ActionButton';
const ActionAnchor = ({ className, href, target = '_self', variant = 'primary', children }) => {
    const buttonStyles = getActionButtonStyles();
    return (React.createElement("a", { className: classNames(buttonStyles.root, buttonStyles[variant], className), href: href, target: target }, children));
};
export default ActionAnchor;
//# sourceMappingURL=ActionAnchor.js.map